define.alias("ember-math-helpers/helpers/acosh", "calendar/helpers/acosh");